const Accounting = [
    "Accounting",
    "Bookkeeping",
    "Financial Accounting",
    "Financial Advisory",
    "Mortgage Lending",
    "Personal Tax Planning",
    "Small Business Tax",
    "Tax Preparation"
];

const CoachingMentoring = [
    "Career Development Coaching",
    "Change Management",
    "Corporate Training",
    "Diversity & Inclusion",
    "Executive Coaching",
    "Interview Preparation",
    "Leadership Development",
    "Life Coaching",
    "Negotiation",
    "Public Speaking",
    "Resume Review",
    "Resume Writing",
    "Team Building",
    "Training"
];

const Consulting = [
    "Advertising",
    "Brand Consulting",
    "Business Consulting",
    "Educational Consulting",
    "Email Marketing",
    "Environmental Consulting",
    "Financial Consulting",
    "HR Consulting",
    "Healthcare Consulting",
    "Legal Consulting",
    "Management Consulting",
    "Marketing Consulting",
    "Non-profit Consulting",
    "Political Consulting",
    "Pricing Strategy",
    "Project Management",
    "Public Relations",
    "Search Engine Marketing (SEM)",
    "Search Engine Optimization (SEO)",
    "Tax Advisory"
];

const Design = [
    "3D Design",
    "Ad Design",
    "Animation",
    "Brand Design",
    "Engineering Design",
    "Graphic Design",
    "Illustration",
    "Industrial Design",
    "Interaction Design",
    "Interior Design",
    "Logo Design",
    "Packaging Design",
    "Presentation Design",
    "Print Design",
    "UX Research",
    "User Experience Design (UED)",
    "Video Editing",
    "Video Production",
    "Videography",
    "Visual Design",
    "Web Design",
    "WordPress Design"
];

const Events = [
    "Audio Engineering",
    "Bartending",
    "Catering",
    "Corporate Events",
    "DJing",
    "Event Coordination",
    "Event Photography",
    "Event Planning",
    "Event Production",
    "Floral Design",
    "Live Events",
    "Photo Booths",
    "Product Launch Events",
    "Sound Design",
    "Trade Shows",
    "Wedding Officiating",
    "Wedding Planning"
];

const Finance = [
    "Budgeting",
    "Financial Accounting",
    "Financial Advisory",
    "Financial Analysis",
    "Financial Planning",
    "Financial Reporting",
    "Insurance",
    "Loans",
    "Retirement Planning"
];

const HomeImprovement = [
    "Architecture",
    "Interior Design",
    "Landscape Design"
];

const InformationTechnology = [
    "Backup & Recovery Systems",
    "Computer Networking",
    "Computer Repair",
    "Cybersecurity",
    "Data Recovery",
    "Home Networking",
    "IT Consulting",
    "Network Support",
    "Telecommunications"
];

const Insurance = [
    "Auto Insurance",
    "Commercial Insurance",
    "Health Insurance",
    "Homeowners Insurance",
    "Insurance",
    "Life Insurance",
    "Small Business Insurance",
    "Title Insurance"
];

const Law = [
    "Bankruptcy Law",
    "Business Law",
    "Consumer Law",
    "Copyright Law",
    "Corporate Law",
    "Criminal Defense Law",
    "DUI Law",
    "Divorce Law",
    "Entertainment Law",
    "Estate Planning Law",
    "Family Law",
    "IT Law",
    "Immigration Law",
    "Intellectual Property Law",
    "Labor and Employment Law",
    "Legal Consulting",
    "Notary",
    "Patent Law",
    "Personal Injury Law",
    "Property Law",
    "Startup Law",
    "Tax Law",
    "Trademark Law",
    "Trust and Estate Litigation",
    "Wills Planning Law"
];

const Marketing = [
    "Advertising",
    "Blogging",
    "Brand Marketing",
    "Content Marketing",
    "Content Strategy",
    "Demand Generation",
    "Digital Marketing",
    "Direct Mail Marketing",
    "Email Marketing",
    "Event Marketing",
    "Growth Marketing",
    "Lead Generation",
    "Market Research",
    "Marketing Consulting",
    "Marketing Strategy",
    "Mobile Marketing",
    "Performance Marketing",
    "Product Marketing",
    "Public Relations",
    "Real Estate Marketing",
    "Search Engine Marketing (SEM)",
    "Search Engine Optimization (SEO)",
    "Social Media Marketing"
];

const Operations = [
    "Administrative Assistance",
    "Appointment Scheduling",
    "Customer Service",
    "Customer Support",
    "Data Entry",
    "Data Reporting",
    "Executive Administrative Assistance",
    "File Management",
    "Filing",
    "Human Resources (HR)",
    "Invoice Processing",
    "Online Research",
    "Outsourcing",
    "Payroll Services",
    "Personal Assistance",
    "Program Management",
    "Project Management",
    "Research Skills",
    "Strategic Planning",
    "Technical Support",
    "Transcription",
    "Typing",
    "Virtual Assistance"
];

const Photography = [
    "Commercial Photography",
    "Corporate Photography",
    "Event Photography",
    "Food Photography",
    "Headshot Photography",
    "Nature Photography",
    "Pet Photography",
    "Photo Booths",
    "Portrait Photography",
    "Real Estate Photography",
    "Restaurant Photography",
    "Sports Photography",
    "Stock Photography",
    "Video Animation",
    "Video Editing",
    "Videography",
    "Wedding Photography"
];

const RealEstate = [
    "Commercial Lending",
    "Commercial Real Estate",
    "Mortgage Lending",
    "Property Law",
    "Property Management",
    "Real Estate",
    "Real Estate Appraisal",
    "Real Estate Marketing",
    "Relocation"
];

const SoftwareDevelopment = [
    "Android Development",
    "Application Development",
    "Business Analytics",
    "Cloud Application Development",
    "Cloud Management",
    "Custom Software Development",
    "Database Development",
    "Enterprise Content Management",
    "Information Management",
    "Information Security",
    "Mobile Application Development",
    "SaaS Development",
    "Software Testing",
    "User Experience Design (UED)",
    "Web Design",
    "Web Development",
    "iOS Development"
];

const Writing = [
    "Blogging",
    "Content Strategy",
    "Copywriting",
    "Editing",
    "Ghostwriting",
    "Grant Writing",
    "Technical Writing",
    "Translation",
    "User Experience Writing",
    "Writing"
];

export const servicesContext = [
    { title: 'Accounting', skills: Accounting },
    { title: 'Coaching & Mentoring', skills: CoachingMentoring },
    { title: 'Consulting', skills: Consulting },
    { title: 'Design', skills: Design },
    { title: 'Events', skills: Events },
    { title: 'Finance', skills: Finance },
    { title: 'Home Improvement', skills: HomeImprovement },
    { title: 'Information Technology', skills: InformationTechnology },
    { title: 'Insurance', skills: Insurance },
    { title: 'Law', skills: Law },
    { title: 'Marketing', skills: Marketing },
    { title: 'Operations', skills: Operations },
    { title: 'Photography', skills: Photography },
    { title: 'Real Estate', skills: RealEstate },
    { title: 'Software Development', skills: SoftwareDevelopment },
    { title: 'Writing', skills: Writing }
];
